module.exports = __webpack_public_path__ + "img/solutions-bg.039e7421.svg";